import React from 'react';

interface ThumbsUpIconProps {
  className?: string;
  stroke?: string;
}

export default function ThumbsUpIcon({ className, stroke = 'currentColor' }: ThumbsUpIconProps) {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.75 12.6875H9.375V24.875H3.75C3.50136 24.875 3.2629 24.7762 3.08709 24.6004C2.91127 24.4246 2.8125 24.1861 2.8125 23.9375V13.625C2.8125 13.3764 2.91127 13.1379 3.08709 12.9621C3.2629 12.7863 3.50136 12.6875 3.75 12.6875V12.6875Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 12.6875L14.0625 3.3125C15.0571 3.3125 16.0109 3.70759 16.7141 4.41085C17.4174 5.11411 17.8125 6.06794 17.8125 7.0625V9.875H25.0664C25.3323 9.87434 25.5952 9.93059 25.8375 10.04C26.0798 10.1493 26.296 10.3093 26.4713 10.5091C26.6467 10.7089 26.7773 10.9439 26.8544 11.1984C26.9314 11.4528 26.9531 11.7208 26.918 11.9844L25.5117 23.2344C25.4548 23.686 25.2356 24.1015 24.8949 24.4034C24.5542 24.7052 24.1153 24.8729 23.6602 24.875H9.375"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
} 